import React from "react";
import StatsStrip from "../components/Statsstrip";
import HomeAbout from "../components/home-about";
import Events from "../components/cards";
import Hero from "../components/Hero";
import SupportedBy from "../components/supportedBy";
import Experience from "../components/Experience";
import NewsletterCTA from "../components/NewsletterCTA";
import "./home.css";

const Homepage = () => {
  return (
    <>
      <div className="page-offset">

        {/* HERO */}
        <section className="Hero">
          <Hero />
        </section>
        <HomeAbout />

        {/* EVENTS */}
        <section className="events-section">
  <section className="events-section">
  <h3 className="events-heading">Our 2026 Calendar</h3>

  <div className="events-grid">
    <Events
      eventImg="/images/2N0A0025.jpg"
      eventTitle="Easter Edition"
      button="/events/easter"
      index={1}
    />
    <Events
      eventImg="/images/DSC_3784.jpg"
      eventTitle="Summer Edition"
      button="/eventpage"
      index={2}
    />
    <Events
      eventImg="/images/mascot.jpg"
      eventTitle="Global Village Edition"
      button="/events/global-village"
      index={3}
      featured
    />
    <Events
      eventImg="/images/GRD_0207.webp"
      eventTitle="Christmas Edition"
      button="/events/christmas"
      index={4}
    />
  </div>
</section>
      </section>
        
        <StatsStrip/>
        <Experience />

        <SupportedBy />

      </div>
    </>
  );
};

export default Homepage;